module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"checkyoursymptoms":"გადაამოწმე სიმპტომები AI-ს დახმარებით","startInterview":"კითხვარის დაწყება","male":"მამრობითი","female":"მდედრობითი","age":"ასაკი","gender":"სქესი"},"en":{"checkyoursymptoms":"Check your symptoms using AI","startInterview":"Start Symptom Checker","male":"Male","female":"Female","age":"Age","gender":"Gender"}}')
  delete Component.options._Ctor
}
